// extracted by mini-css-extract-plugin
export default {"p":"_909059a7c3 a04188f9fb _27d951b9da","clr":"_2626cefbad","dls":"d1b073dd6c"};